import type { ApolloError } from "@apollo/client";

const NO_ENTITY_ACCESS_MESSAGE = "You do not have access to any entities in this arena";

/**
 * The compliance backend rejects arena-level queries with this authz error when
 * the user has no accessible entities. Consumers show a dedicated page or an
 * empty state for it instead of the generic QueryLoader error screen.
 */
export const isNoEntityAccessError = (error: ApolloError | undefined): boolean =>
  (error?.graphQLErrors ?? []).some((err) => err.message.includes(NO_ENTITY_ACCESS_MESSAGE));
